import React, { useEffect, useState, useRef } from "react";

export default function MouseParticles({ pos }) {
  const [particles, setParticles] = useState([]);
  const lastPosRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    if (pos.x === -1000) return;

    // Calculate mouse speed
    const dx = pos.x - lastPosRef.current.x;
    const dy = pos.y - lastPosRef.current.y;
    const speed = Math.sqrt(dx * dx + dy * dy);
    lastPosRef.current = { x: pos.x, y: pos.y };

    // Create particles based on speed (more particles when moving fast)
    const shouldCreateParticle = Math.random() < Math.min(speed / 20, 0.8);
    
    if (shouldCreateParticle) {
      const newParticle = {
        id: Date.now() + Math.random(),
        x: pos.x,
        y: pos.y,
        vx: (Math.random() - 0.5) * 2,
        vy: (Math.random() - 0.5) * 2,
        size: Math.random() * 6 + 3,
        color: speed > 10 
          ? `rgba(255, 107, 53, ${Math.random() * 0.8 + 0.2})` // Orange when fast
          : `rgba(0, 212, 255, ${Math.random() * 0.8 + 0.2})`, // Cyan when slow
        life: 1,
      };

      setParticles((prev) => [...prev.slice(-30), newParticle]);
    }

    // Update particle positions
    setParticles((prev) =>
      prev
        .map((p) => ({
          ...p,
          x: p.x + p.vx,
          y: p.y + p.vy,
          life: p.life - 0.02,
        }))
        .filter((p) => p.life > 0)
    );
  }, [pos]);

  return (
    <div className="mouse-particles">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="mouse-particle"
          style={{
            left: particle.x,
            top: particle.y,
            width: particle.size,
            height: particle.size,
            background: particle.color,
            opacity: particle.life,
            transform: `translate(-50%, -50%) scale(${particle.life})`,
          }}
        />
      ))}
    </div>
  );
}
